module.exports = __webpack_public_path__ + "static/media/expand-icon.5babf895.svg";